import { useCallback, useEffect, useState } from 'react'
import { useStore } from 'store/store'
import { useSpaceId } from 'use-towns-client'

import { useDebounce } from './useDebounce'
import { useJoinedChannels } from './useSortedChannels'
import { useSpaceChannels } from './useSpaceChannels'

export const useUnseenChannelIds = () => {
    const spaceId = useSpaceId()
    const seenChannelIds = useStore(({ seenChannelIds }) => seenChannelIds)
    const setSeenChannelIds = useStore(({ setSeenChannelIds }) => setSeenChannelIds)

    const allChannels = useSpaceChannels()
    const { joinedChannels } = useJoinedChannels(spaceId)
    const [unseenChannelIds, setUnseenChannelIds] = useState<Set<string>>(new Set<string>())

    useEffect(() => {
        const ids = new Set(seenChannelIds)
        const unseenIds = allChannels
            .filter((channel) => !joinedChannels.has(channel.id) && !ids.has(channel.id))
            .map((channel) => channel.id)
        setUnseenChannelIds(new Set<string>(unseenIds))
    }, [seenChannelIds, allChannels, joinedChannels, setSeenChannelIds])

    const markChannelsAsSeen = useCallback(() => {
        const ids = allChannels.map((channel) => channel.id)
        const allSeenChannelIds = new Set([...seenChannelIds, ...ids])
        setSeenChannelIds(Array.from(allSeenChannelIds))
    }, [seenChannelIds, setSeenChannelIds, allChannels])

    // Debounce the value slightly to avoid flickering badges
    const debouncedUnseenChannelIds = useDebounce<Set<string>>(unseenChannelIds, 500)
    return { unseenChannelIds: debouncedUnseenChannelIds, markChannelsAsSeen }
}
